import { FC, useState} from "react";
import Select, { GroupBase, OptionsOrGroups, SingleValue } from "react-select";
import { Controller, useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { format, parse } from "date-fns";

import StatsReports from "../statsReports";
import { StatisticsPropsType, StatisticsSearchProps } from "./types";




const CaseFilter: FC<StatisticsPropsType> = ({
  updateQueryParams,
  defaultQueryParams,
}): JSX.Element => {
  const [openStartDatePicker, changeStartDatePickerVisibility] = useState<boolean>(false)
  const [openEndDatePicker, changeEndDatePickerVisibility] = useState<boolean>(false)

  const { control, handleSubmit, getValues, watch } = useForm<StatisticsSearchProps>({
    mode: "all",
    defaultValues: defaultQueryParams,
  });
    const start_date = watch("start_date");
    const end_date = watch("end_date");

  const timeData = [
    { value: "day", label: "Group by Day" },
    { value: "week", label: "Group by Week" },
    { value: "month", label: "Group by Month" },
    { value: "quarter", label: "Group by Quarter" },
  ];
  const comparison = [
    { value: "p-1", label: "Compare with previous Period" },
    { value: "y-1", label: "Compare with Previous Year" },
  ]

  const searchForStats = (values: StatisticsSearchProps) => {
    const updatedValues = {
      ...values,
      user_id: defaultQueryParams?.user_id || "0",
      type: defaultQueryParams?.type || "",
      // period: values.period
      //   ? typeof values.period === "string"
      //     ? values.period
      //     : (values.period as unknown as { value: string; label: string }).value
      //   : "",
      // soc_value:
      //   values.soc_value ?
      //     (typeof values.soc_value === "string" ? values.soc_value : (values.soc_value as unknown as { value: string; name: string; }).value)
      //     : "",
      // drug_id:
      //   values.drug_id ?
      //     (typeof values.drug_id === "string" ? values.drug_id : (values.drug_id as unknown as { value: string; name: string; }).value)
      //     : "",
      // filter_type: values.filter_type
      //   ? typeof values.filter_type === "string"
      //     ? values.filter_type
      //     : (values.filter_type as unknown as { value: string; label: string }).value
      //   : "",
      // user_id:
      //   values.user_id ?
      //     (typeof values.user_id === "string" ? values.user_id : (values.user_id as unknown as { value: string; name: string; }).value)
      //     : "",
    };

    updateQueryParams(updatedValues, false);
  };

  const onFocusDropdown = () => {
    changeStartDatePickerVisibility(false)
    changeEndDatePickerVisibility(false)
  }

 

  return (
    <form onSubmit={handleSubmit(searchForStats)}>
      <div className="card mt-0 mt-md-4">
        <div className="card-header">
          <h4 className="text-primary m-0">Statistics</h4>
        </div>
        <div className="card-body px-3 pt-3">
          <div className="row statistics-filter mb-3">
            <div className="col mb-2">
              <div className="row">
                <label className={"form-label col-lg-4 col-md-4 col-12"}>Start date</label>

                <div className="col-lg-8 col-md-8 col-12">
                  <div className="position-relative">
                    <Controller
                      name="start_date"
                      control={control}
                      defaultValue=""
                      render={({field}) => (
                        <DatePicker
                          open={openStartDatePicker}
                          onClickOutside={() =>
                            changeStartDatePickerVisibility(false)
                          }
                          onFocus={() => changeStartDatePickerVisibility(true)}
                          onBlur={(e) => {
                            if (!e.currentTarget.contains(document.activeElement))
                              changeStartDatePickerVisibility(false)
                          }}
                          selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                          onChange={(date) => {
                            if (date)
                              field.onChange(format(date, "yyyy-MM-dd"))
                            changeStartDatePickerVisibility(false)
                          }}
                          customInput={
                            <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                              <input {...inputProps} />}
                            </ReactInputMask>
                          }
                          className="form-control form-control-datepicker rounded-1" wrapperClassName="w-100"
                          placeholderText="mm/dd/yyyy"
                          dateFormat="MM/dd/yyyy"
                          showMonthDropdown
                          showYearDropdown
                          maxDate={end_date ? new Date(end_date) : undefined}
                        />
                      )}
                    />
                    <i
                      className="bi bi-calendar position-absolute"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col mb-2">
              <div className="row">
                <label className="form-label col-lg-4 col-md-4 col-12">End date</label>
                
                <div className="col-lg-8 col-md-8 col-12">
                  <div className="position-relative">
                    <Controller
                      name="end_date"
                      control={control}
                      defaultValue=""
                      render={({field}) => (
                        <DatePicker
                          open={openEndDatePicker}
                          onClickOutside={() =>
                            changeEndDatePickerVisibility(false)
                          }
                          onFocus={() => changeEndDatePickerVisibility(true)}
                          onBlur={(e) => {
                            if (!e.currentTarget.contains(document.activeElement))
                              changeEndDatePickerVisibility(false)
                          }}
                          selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                          onChange={(date) => {
                            if(date)
                              field.onChange(format(date, "yyyy-MM-dd"))
                            changeStartDatePickerVisibility(false)
                          }}
                          customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) => <input {...inputProps} />}</ReactInputMask>}
                          className="form-control form-control-datepicker rounded-1" wrapperClassName="w-100"
                          placeholderText="mm/dd/yyyy"
                          dateFormat="MM/dd/yyyy"
                          showMonthDropdown
                          showYearDropdown
                          minDate={start_date ? new Date(start_date) : undefined}
                        />
                      )}
                    />
                    <i
                      className="bi bi-calendar position-absolute"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col min-col mb-2" onFocus={onFocusDropdown} tabIndex={-1}>
              <Controller
                name="period"
                control={control}
                defaultValue=""
                render={({field}) => (
                  <Select
                    isClearable={true}
                    placeholder={"Group Report By..."}
                    options={
                      timeData.map((item) => ({
                        value: item.value,
                        label: item.label,
                      })) as unknown as OptionsOrGroups<
                        string,
                        GroupBase<string>
                      >
                    }
                    id="time"
                    {...field}
                    value={
                      timeData.find((item) => item.value === field.value) as unknown as SingleValue<unknown>
                    }
                    onChange={(val) => {
                      if (val)
                        field.onChange((val as { value: string; label: string; }).value)
                      else
                        field.onChange("")
                    }}
                  />
                )}
              />
            </div>

            <div className="col min-col mb-2" onFocus={onFocusDropdown} tabIndex={-1}>
              <Controller
                name="filter_type"
                control={control}
                defaultValue=""
                render={({field}) => (
                  <Select
                    isClearable={true}
                    placeholder={"Compare With ..."}
                    options={
                      (comparison && comparison.length > 0
                        ? comparison.map((item) => ({
                          value: item.value,
                          label: item.label,
                        }))
                        : []
                      ) as unknown as OptionsOrGroups<
                        string,
                        GroupBase<string>
                      >
                    }
                    id="time"
                    {...field}
                    value={
                      comparison.find((item) => item.value === field.value) as unknown as SingleValue<unknown>
                    }
                    onChange={(val) => {
                      if (val)
                        field.onChange((val as { value: string; label: string; }).value)
                      else
                        field.onChange("")
                    }}
                  />
                )}
              />
            </div>

            <div className="col">
              <button type="submit" className="btn btn-primary w-100">
                <i className="fas fa-sync-alt"></i> Refresh
              </button>
            </div>
          </div>

          <StatsReports getValues={getValues} role={defaultQueryParams?.role || ""} />
        </div>
      </div>
    </form>
  );
};

export default CaseFilter;
